import { useQuery } from '@tanstack/react-query';
import { api } from '../utils/api';

export interface SystemSettings {
  nameplate_display: 'name' | 'asset_tag' | 'serial';
  show_weight: boolean;
  show_power: boolean;
  show_airflow: boolean;
  show_tenant: boolean;
  show_groups: boolean;
  show_organizations: boolean;
  show_warranty: boolean;
  show_contacts: boolean;
  default_projection: 'front' | 'rear' | 'split';
  show_zero_u: boolean;
  show_empty_slots: boolean;
  ai_provider: string;
  openai_api_key: string;
  openai_model: string;
  openai_base_url: string;
}

const DEFAULTS: SystemSettings = {
  nameplate_display: 'name',
  show_weight: true,
  show_power: true,
  show_airflow: false,
  show_tenant: false,
  show_groups: false,
  show_organizations: false,
  show_warranty: false,
  show_contacts: false,
  default_projection: 'split',
  show_zero_u: true,
  show_empty_slots: true,
  ai_provider: 'ollama',
  openai_api_key: '',
  openai_model: 'gpt-4o-mini',
  openai_base_url: 'https://api.openai.com/v1',
};

/**
 * Fetches system-wide settings from the backend.
 * Results are cached for 5 minutes and shared across all components.
 * Falls back to defaults if the request fails (e.g. unauthenticated).
 */
export function useSystemSettings(): SystemSettings {
  const { data } = useQuery<SystemSettings>({
    queryKey: ['system-settings'],
    queryFn: () => api.get('/api/admin/system-settings').then(r => r.data),
    staleTime: 5 * 60_000,
    // On 401/403 return defaults silently — non-admin viewers still get defaults
    retry: false,
  });
  return data ?? DEFAULTS;
}
